import { useRef } from 'react'
import { useSearchParams } from 'react-router-dom'

export function useTablePageParam(
  paramName = 'page'
): [number, (page: number) => void] {
  const [searchParams, setSearchParams] = useSearchParams()

  const setSearchParamsRef = useRef(setSearchParams)
  setSearchParamsRef.current = setSearchParams

  const rawPage = parseInt(searchParams.get(paramName) ?? '1', 10)
  const page = isNaN(rawPage) || rawPage < 1 ? 0 : rawPage - 1

  const setPage = (newPage: number) => {
    setSearchParamsRef.current(
      prev => {
        const newParams = new URLSearchParams(prev)
        if (newPage <= 0) {
          newParams.delete(paramName)
        } else {
          newParams.set(paramName, String(newPage + 1))
        }
        return newParams
      },
      { replace: true }
    )
  }

  return [page, setPage]
}
